import React from "react";
import { Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";

function PaginationComp({ size, gutter, variant, bg, circle, currentpage, setCurrentPage }) {
  const maxDisplay = 10;

  let startPage = Math.max(1, currentpage - Math.floor(maxDisplay / 2));
  let endPage = Math.min(size, startPage + maxDisplay - 1);
  if (endPage - startPage + 1 < maxDisplay) startPage = Math.max(1, endPage - maxDisplay + 1);

  const items = [];
  for (let number = startPage; number <= endPage; number++) {
    items.push(
      <Pagination.Item key={number} onClick={() => setCurrentPage(number)} active={number === currentpage}>
        {number}
      </Pagination.Item>
    );
  }

  return (
    <Pagination className={`${gutter ? "pagination-gutter" : ""} ${variant ? `pagination-${variant}` : ""} ${!bg ? "no-bg" : ""} ${circle ? "pagination-circle" : ""}`}>
      <li className={`page-item page-indicator ${currentpage === 1 ? 'disabled' : ''}`}>
        <Link className="page-link" to="#" onClick={() => currentpage > 1 && setCurrentPage(currentpage - 1)}>
          <i className="la la-angle-left" />
        </Link>
      </li>
      {items}
      <li className={`page-item page-indicator ${currentpage === size ? 'disabled' : ''}`}>
        <Link className="page-link" to="#" onClick={() => currentpage < size && setCurrentPage(currentpage + 1)}>
          <i className="la la-angle-right" />
        </Link>
      </li>
    </Pagination>
  );
}

export default PaginationComp;